/**
 * Display-name formatting helpers.
 *
 * County land records and some MLS fields deliver names in ALL CAPS
 * ("WAILEA ELUA", "POLO BEACH CLUB"). Elsewhere in the repo names arrive
 * already correctly cased ("Wailea Elua", "Ho'olei", "La'i Loa"). For public
 * display we want a single consistent look without mangling the already-good
 * names.
 *
 * Rule: if the string contains any lowercase letter, leave it alone. Only
 * re-case strings that are entirely uppercase (ignoring digits and punctuation).
 */
// Roman numerals up to 20 — preserve as uppercase when they appear as a
// stand-alone word (common in phase / development names: "PHASE II", "PH-III").
const ROMAN_NUMERALS = new Set([
    'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X',
    'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX',
]);
/**
 * Title-case a single word: first letter upper, rest lower. Apostrophes and
 * hyphens are preserved in place; the letter immediately after them is NOT
 * re-capitalized, which gives us the natural form of Hawaiian names like
 * "Ali'i" and "Pi'ilani" when starting from ALL CAPS input.
 */
function titleCaseWord(word) {
    if (!word)
        return word;
    if (ROMAN_NUMERALS.has(word))
        return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
/**
 * Normalize a neighborhood (or any short proper-noun) display name.
 *
 * Preserves already-cased names; re-cases ALL-CAPS input to Title Case.
 */
export function formatNeighborhoodName(name) {
    if (!name)
        return '';
    // Any lowercase letter → assume the caller already formatted it.
    if (/[a-z]/.test(name))
        return name;
    // Split on spaces, title-case each word.
    return name
        .split(/(\s+)/)
        .map((chunk) => (/\s+/.test(chunk) ? chunk : titleCaseWord(chunk)))
        .join('');
}
//# sourceMappingURL=displayName.js.map